__turbopack_context__.v({
  "enterYourEmail": "text-field1-module-scss-module__dcf1Kq__enterYourEmail",
  "error": "text-field1-module-scss-module__dcf1Kq__error",
  "errorText": "text-field1-module-scss-module__dcf1Kq__errorText",
  "label": "text-field1-module-scss-module__dcf1Kq__label",
  "row": "text-field1-module-scss-module__dcf1Kq__row",
  "textField": "text-field1-module-scss-module__dcf1Kq__textField",
});
